//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      giftCardNumber: null,
      pinCode: null
    };
  },
  computed: {
    modalWidth() {
      return this.$mq === "sm" ? "95%" : "80%";
    }
  },
  methods: {
    closeModal() {
      this.$modal.hide("check-balance-modal");
    },
    checkGiftCardBalance() {
      console.log("checkGiftCardBalance");
    }
  }
};
